module.exports = __webpack_public_path__ + "static/media/program.a105e9b9.jpg";